import { Prettify, signalStore, withMethods } from '@ngrx/signals';
import { withSavedPartList } from './features/withSavedPartList';

export const SavedPartListComponentStore = signalStore(
  withSavedPartList(),
  withMethods((store) => {
    const selectCartById = (id: string | undefined | null) => {
      store._selectCartById(id ?? '');
    };
    return {
      selectCartById,
    };
  }),
);
export type SavedPartListComponentStore = Prettify<InstanceType<typeof SavedPartListComponentStore>>;
